module.exports = __webpack_public_path__ + "static/media/ai.e2aa8369.jpg";